<script>
	// @ts-ignore
	import ConfettiGenerator from 'confetti-js';
	import { onMount } from 'svelte';

	onMount(() => {
		const confettiSettings = {
			target: 'confetti',
			max: 400,
			props: [
				'circle',
				'square',
				{ type: 'svg', src: 'trading-season/points.svg', weight: 0.05, size: 25 }
			],
			start_from_edge: true,
			clock: 40
		};
		const confetti = new ConfettiGenerator(confettiSettings);
		confetti.render();
	});
</script>

<canvas id="confetti" class="absolute top-0 right-0 left-0 bottom-0 z-0" />
